import React from 'react';
import Icon, { IconType } from '../../icons/Icon';

export namespace Feedback {
  export interface Props {
    text?: string;
    type: Type;
  }

  export enum Type {
    success = 'success',
    error = 'error',
  }

  export const style = (type: Type) => {
    return {
      border: borders[type],
      icon: icons[type],
      textColor: textColors[type],
      backgroundColor: backgroundColors[type],
      strokeColor: strokeColors[type],
    };
  };

  export const borders = {
    error: 'border-error-500',
    success: 'border-success-500',
  } as const;

  export const icons = {
    error: <Icon type={IconType.alertCircle} stroke={'stroke-error-500'} size={'h-4 w-4'} />,
    success: <Icon type={IconType.checkCircle} stroke={'stroke-success-500'} size={'h-4 w-4'} />,
  } as const;

  export const textColors = {
    error: 'text-error-500',
    success: 'text-success-500',
  } as const;

  export const backgroundColors = {
    error: 'bg-error-500',
    success: 'bg-success-500',
  } as const;

  export const strokeColors = {
    error: 'stroke-error-500',
    success: 'stroke-success-500',
  } as const;

  export const mandatoryProps: Props = { text: 'This field is required', type: Type.error };
  export function mandatory<T>(value?: T | undefined): Props | undefined {
    if (!value) return mandatoryProps;
  }
}
